import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import InspectionProfileNative from "./InspectionProfile.native";
import storageService from "../../../../services/storage.service";
import UserSession from "../../../../models/session/user-session.entity";
import AppletProfileSession from "../../../../models/session/applet-profile-session.entity";
import appletProfileIdAction from "../../../../redux/actions/appletProfileIdAction";
import plateAction from "../../../../redux/actions/plateAction";
import vehicleDataAction from "../../../../redux/actions/vehicleDataAction";
import uniqueInspectionIDAction from "../../../../redux/actions/uniqueInspectionIDAction";
import InspectionDbService from "../../../../services/indexedDB/inspection/inspection-db.service";
import { ProtectedRoute } from "../../../Auth/ProtectedRoute/ProtectedRoute ";
import connectionService from "../../../../services/connection/connection.service";
import { AppletSegmentTypeEnum } from "../../../../models/session/applet-segment-type.enum";

const InspectionProfileContainer = (props: any) => {
  const [profiles, setProfiles] = useState<AppletProfileSession[]>([]);
  const [selectedProfile, setSelectedProfile] = useState<string>('');
  const [plate, setPlate] = useState<string>('');
  const [vehicleType, setVehicleType] = useState<string>('');
  const [brand, setBrand] = useState<string>('');
  const [version, setVersion] = useState<string>('');
  const [yearManufacture, setYearManufacture] = useState<string>('');
  const [isOffline, setIsOffline] = useState<boolean>(!connectionService.hasConnection());

  const history = useHistory();

  const selectedProfileObj = profiles.find(
    (profile) => profile.appletProfileId === selectedProfile
  );
  const isAgriculturalProfile = selectedProfileObj?.segmentType === AppletSegmentTypeEnum.AGRICULTURAL_MACHINERY;

  const getProfilesFromSession = () => {
    const session = storageService.getObject('session')
      ? new UserSession(storageService.getObject('session'))
      : new UserSession();

    setProfiles(session.company.profiles);
  }

  const handleChanges = (e: any) => {
    const { value } = e.target;
    setSelectedProfile(value);
  }

  const onChangePlate = (e: any) => {
    const { value } = e.target;
    const maxLength = isAgriculturalProfile ? 17 : 7;
    const sanitized = value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, maxLength);
    setPlate(sanitized);
  }

  const startInspection = () => {
    props.appletProfileIdAction(selectedProfile);
    props.plateAction(plate);
    props.vehicleDataAction(isAgriculturalProfile
      ? {
        vehicleType,
        brand,
        model: version,
        version,
        yearManufacture,
      }
      : null);
    props.uniqueInspectionIDAction(InspectionDbService.getUniqIdentifier());
    history.push('/new-inspection/location');
  }

  useEffect(() => {
    getProfilesFromSession();

    const updateConnection = () => setIsOffline(!connectionService.hasConnection());
    window.addEventListener('online', updateConnection);
    window.addEventListener('offline', updateConnection);

    return () => {
      window.removeEventListener('online', updateConnection);
      window.removeEventListener('offline', updateConnection);
    };
  }, []);

  return (
    <ProtectedRoute>
      <InspectionProfileNative
        profiles={profiles}
        handleChanges={handleChanges}
        selectedProfile={selectedProfile}
        plate={plate}
        onChangePlate={onChangePlate}
        startInspection={startInspection}
        isOffline={isOffline}
        isAgriculturalProfile={isAgriculturalProfile}
        vehicleType={vehicleType}
        onChangeVehicleType={(e: any) => setVehicleType(e.target.value)}
        brand={brand}
        onChangeBrand={(e: any) => setBrand(e.target.value)}
        version={version}
        onChangeVersion={(e: any) => setVersion(e.target.value)}
        yearManufacture={yearManufacture}
        onChangeYearManufacture={(e: any) => setYearManufacture(e.target.value.replace(/[^0-9]/g, '').slice(0, 4))}
      />
    </ProtectedRoute>
  );
};

const mapStateToProps = (state: any) => ({
  ...state
});

const mapDispatchToProps = (dispatch: any) => ({
  appletProfileIdAction: (payload: string) => dispatch(appletProfileIdAction(payload)),
  plateAction: (payload: string) => dispatch(plateAction(payload)),
  vehicleDataAction: (payload: any) => dispatch(vehicleDataAction(payload)),
  uniqueInspectionIDAction: (payload: string) => dispatch(uniqueInspectionIDAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InspectionProfileContainer);
